import React, { Component } from "react";
import "./news.css";
import { getOnlineNews } from "../../services/newsService";
import NewsElement from "./newsElement";
 
export default class newsMobile extends Component {

    state = {
        news: []
    };

    async componentDidMount() {
        const result = await getOnlineNews();
        this.setState({ news: result.data });
    }

    render() {
        return (
                <div className="container news-content">
                    <div className="row hrow news-box">
                        <section>
                            {this.state.news.map(element => (
                                <NewsElement
                                    key={element.Id}
                                    id={element.Id}
                                    title={element.Title}
                                    relaseDate={element.PublishDateInText}
                                    firstParagraph={element.FirstParagraphContent}
                                    imageUrl={element.FirstImageUrl}
                                />
                            ))}
                        </section>
                    </div>
                </div>
        );
    }
}
